import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { POLICIES, UPDATED } from "@/content/policies";
import { useSeo } from "@/lib/seo";

export default function Policy() {
  const { slug } = useParams();
  const policy = POLICIES[slug];
  useSeo({
    title: policy ? `${policy.title} | Insane Circle Socks` : "Page not found | Insane Circle",
    description: policy ? policy.intro : "This page does not exist on Insane Circle.",
    path: `/policies/${slug}`,
    noindex: !policy,
  });

  if (!policy) {
    return (
      <section data-testid="policy-not-found" className="flex min-h-screen items-center px-5 pt-24 md:px-10">
        <div className="mx-auto max-w-3xl text-center">
          <h1 className="font-display text-4xl font-extrabold uppercase sm:text-6xl">Page not found</h1>
          <Link to="/" className="mt-8 inline-block rounded-full bg-lime px-8 py-4 font-display font-extrabold uppercase text-ink">Back home</Link>
        </div>
      </section>
    );
  }

  return (
    <article data-testid={`policy-page-${slug}`} className="px-5 pb-24 pt-32 md:px-10 md:pt-40">
      <div className="mx-auto max-w-3xl">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-pink">Last updated · {UPDATED}</p>
        <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          data-testid="policy-title" className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.9] tracking-tight sm:text-5xl lg:text-6xl">
          {policy.title}
        </motion.h1>
        <p className="mt-8 text-base text-haze md:text-lg">{policy.intro}</p>
        <div className="mt-12 space-y-10">
          {policy.sections.map((s) => (
            <section key={s.h} className="border-t border-violet/40 pt-8">
              <h2 className="font-display text-xl font-extrabold uppercase text-lime md:text-2xl">{s.h}</h2>
              <div className="mt-4 space-y-3">
                {s.p.map((t) => <p key={t} className="text-base leading-relaxed text-haze">{t}</p>)}
              </div>
            </section>
          ))}
        </div>
      </div>
    </article>
  );
}
